import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { TextButton, ButtonText } from '@prisjakt/ui/button/variants';
import { Price } from 'src/types';
import { Information } from '../styles';

const PriceListFooter: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceListFooterProps>
>> = props => {
  const {
    showProductInformationTexts,
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    setShowMorePrices,
  } = props;
  const { t } = useContext(AppContext);
  const showMorePricesLabel = `${t(
    'product',
    'prices.show-more-prices-button'
  )} (+${sortedPrices.length - numberOfVisiblePrices})`;

  return (
    <div>
      {showProductInformationTexts && (
        <Information>{t('product', 'price-list.data-information')}</Information>
      )}
      {!showMorePrices && sortedPrices.length > numberOfVisiblePrices && (
        <TextButton
          style={{ margin: '0 auto' }}
          onClick={() => setShowMorePrices(true)}
        >
          <ButtonText>{showMorePricesLabel}</ButtonText>
        </TextButton>
      )}
    </div>
  );
};

export default PriceListFooter;

interface IPriceListFooterProps {
  showProductInformationTexts: boolean | undefined;
  sortedPrices: Price[];
  showMorePrices: boolean;
  numberOfVisiblePrices: number;
  setShowMorePrices: React.Dispatch<React.SetStateAction<boolean>>;
}
